import request from '@/utils/request'

/*
客户订单接口
 */
export function order_list (data) {
    return request({
        url: 'order/list',
        method: 'get',
        params: data
    })
}
/*
历史订单
 */
export function order_history (data) {
    return request({
        url: 'order/order_history',
        method: 'get',
        params: data
    })
}
/*
历史订单
 */
export function order_success_list (data) {
    return request({
        url: 'order/success_order_list',
        method: 'get',
        params: data
    })
}



// 修改售后人员
export function change_turn(data){
    return request({
        url: 'order/turn',
        method: 'post',
        data
    })

}

// 成交订单
export function order_success(data){
    return request({
        url: 'order/deal',
        method: 'post',
        data
    })
}

// 编辑订单
export function order_edit(data){
    return request({
        url: 'order/edit_order',
        method: 'post',
        data
    })
}

// 退款列表
export function order_refund_list(data){
    return request({
        url: 'order/refund_list',
        method: 'post',
        data
    })
}
export function order_refund_list_all(data){
    return request({
        url: 'order/refund_list_all',
        method: 'post',
        data
    })
}

// 申请退款
export function order_refund(data){
    return request({
        url: 'order/add_refund',
        method: 'post',
        data
    })
}

// 删除退款记录
export function delete_refund_order(data){
    return request({
        url: 'order/delete_refund',
        method: 'post',
        data
    })
}
// 删除退款记录
export function del_refund(data){
    return request({
        url: 'order/del_refund',
        method: 'post',
        data
    })
}
// 删除退款记录
export function order_back_refuse(data){
    return request({
        url: 'order/order_back_refuse',
        method: 'post',
        data
    })
}


// 释放订单
export function release_order(data) {
    return request({
        url: 'order/release',
        method: 'post',
        data
    })
}



// 公海订单
export function waters_list(data){
    return request({
        url: 'order/waters',
        method: 'get',
        params:data
    })
}


// 认领订单
export function claim_customer(data) {
    return request({
        url: 'order/claim',
        method: 'post',
        data
    })
}

// 待收尾款订单
export function retainage_order(data){
    return request({
        url: 'order/order_retainage',
        method: 'post',
        data
    })
}
// 确认收取尾款
export function receipt_order(data){
    return request({
        url: 'order/order_receipt',
        method: 'post',
        data
    })
}


// 即将到期
export function expire_order(data){
    return request({
        url:'order/expire',
        method:'get',
        params:data
    })
}

// 续费
export function renew_order(data) {
    return request({
        url:'order/renew',
        method: 'post',
        data
    })
}

// 续费
export function noRenewOrder(data) {
    return request({
        url:'order/no_renew',
        method: 'post',
        data
    })
}
// 售后订单跟进
export function after_follow(data) {
    return request({
        url:'order/order_after_follow',
        method: 'post',
        data
    })
}



// 待售后
export function after_order_customer(data) {
    return request({
        url: 'order/after',
        method: 'get',
        params:data
    })
}



// 订单交付
export function order_deliver(data){
    return request({
        url:'order/delivery',
        method: 'post',
        data
    })
}


// 添加客户订单
export function add_order(data){
    return request({
        url: 'order/addOrder',
        method: 'post',
        data
    })
}
export function order_examine(data){
    return request({
        url: 'order/examineOrder',
        method: 'post',
        data
    })
}
export function order_drawback(data){
    return request({
        url: 'order/drawbackOrder',
        method: 'post',
        data
    })
}


export function order_error(data){
    return request({
        url: 'order/errorOrder',
        method: 'post',
        data
    })
}



// 客户订单详情
export function order_detail(data){
    return request({
        url: 'order/details',
        method: 'get',
        params:data
    })
}


// 删除订单
export function order_delete(data){
    return request({
        url: 'order/delete',
        method: 'post',
        data
    })
}
// 锁定订单
export function order_locaking(data){
    return request({
        url: 'order/order_locaking',
        method: 'post',
        data
    })
}
// 置顶订单
export function order_topping(data){
    return request({
        url: 'order/order_topping',
        method: 'post',
        data
    })
}
// 售后的订单操作记录
export function after_history(data){
    return request({
        url: 'order/after_history',
        method: 'get',
        params:data
    })
}

// 售后的订单操作记录
export function success_order(data){
    return request({
        url: 'order/success_order',
        method: 'get',
        params:data
    })
}

// 锁定订单
export function order_back(data){
    return request({
        url: 'order/order_back',
        method: 'post',
        data
    })
}
// 删除跟进记录
export function delete_follow(data){
    return request({
        url: 'order/order_delete_follow',
        method: 'post',
        data
    })
}

// 导出订单
export function export_success_list(data){
    return request({
        url: 'export/index',
        method: 'post',
        data
    })
}

// 导出订单
export function export_history_list(data){
    return request({
        url: 'export/history',
        method: 'post',
        data
    })
}

// 导出过期订单
export function export_expire_order(data){
    return request({
        url: 'export/expire',
        method: 'post',
        data
    })
}
// 导出订单
export function export_refund_list(data){
    return request({
        url: 'export/refund_history',
        method: 'post',
        data
    })
}




// 错误通知列表
export function order_error_list(data){
    return request({
        url: 'order/errorOrderList',
        method: 'post',
        data
    })
}

//  客户报价
export function customerPrice(data){
    return request({
        url: 'order/customerprice',
        method: 'post',
        data
    })
}

//  客户大概功能
export function customerFunction(data){
    return request({
        url: 'order/customerfunction',
        method: 'post',
        data
    })
}




